const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* HeyTaos Shopify Forms teaser contrast, 2026-08-31 */
(() => {
  const STYLE_ID = 'heytaos-forms-teaser-contrast';
  const STYLE_TEXT = `
    button[class*="_teaser"] {
      background: #faf4ea !important;
      border: 1px solid rgba(46, 36, 28, 0.16) !important;
      border-left: 5px solid #1f7a78 !important;
      box-shadow: 0 14px 36px rgba(46, 36, 28, 0.18), 0 3px 10px rgba(46, 36, 28, 0.10) !important;
    }

    button[class*="_teaser"]:focus-visible {
      outline: 3px solid rgba(31, 122, 120, 0.35) !important;
      outline-offset: 2px !important;
    }
  `;

  function injectStyles(host) {
    const shadowRoot = host && host.shadowRoot;
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_TEXT;
    shadowRoot.appendChild(style);

    shadowRoot
      .querySelectorAll('shopify-forms-embed, form-embed')
      .forEach(injectStyles);
  }

  function scanForForms() {
    document
      .querySelectorAll('shopify-forms-embed, form-embed, [id^="app-embed-container-"]')
      .forEach(injectStyles);
  }

  function initializeTeaserContrast() {
    scanForForms();

    const observer = new MutationObserver(scanForForms);
    observer.observe(document.body, { childList: true, subtree: true });

    let attempts = 0;
    const retry = window.setInterval(() => {
      scanForForms();
      attempts += 1;
      if (attempts >= 20) window.clearInterval(retry);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTeaserContrast, { once: true });
  } else {
    initializeTeaserContrast();
  }
})();
